<template>
  <div class="mall">
    <div class="shuffling">
      <el-carousel trigger="click" height="500px">
        <el-carousel-item v-for="(item, index) in shuffling" :key="index">
          <img :src="item.ImgUrl" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="mallList">
      <div
        :class="{ selected: item.Id == selected }"
        @click="goods(item.Id)"
        v-for="(item, index) in mallList"
        :key="index"
      >
        <span>{{ item.Name }}</span>
        <p v-if="item.Id == selected"></p>
      </div>
    </div>
    <div>
      <div class="integralList">
        <div v-for="(item, index) in integralList" :key="index">
          <el-button
            @click="IntegralChange(item.value)"
            :class="{ clic: item.value == Integral }"
            type="primary"
            round
            >{{ item.lable }}</el-button
          >
        </div>
      </div>
      <div
        v-if="goodsList.length == 0"
        style="
          font-size: 2rem;
          color: #999;
          text-align: center;
          position: relative;
          top: 2rem;
        "
      >
        没有数据
      </div>
      <div class="goodsList" v-else>
        <div
          @click="details(item.Id)"
          v-for="(item, index) in goodsList"
          :key="index"
        >
          <img :src="item.ImgDtos[0].ImgUrl" alt="" />
          <span>
            <p style="width: 100%; height: 5rem">
              商品名称:{{ item.GoodsName }}
            </p>
            <p style="width: 100%; color: #f00">积分:{{ item.NeedIntegral }}</p>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { getHome } from "../../api/http/home";
import { getMall } from "../../api/http//mall";
export default {
  data() {
    return {
      Integral: 1, //积分阶段
      integralList: [
        { lable: "全部", value: 1 },
        { lable: "100~200", value: 2 },
        { lable: "200~300", value: 3 },
        { lable: "300~400", value: 4 },
        { lable: "400~500", value: 5 },
        { lable: "500以上", value: 6 },
      ], //积分分布数组
      shuffling: [], //轮播图
      mallList: "", //列表
      selected: "", //选中
      goodsList: "", //商品列表详情
    };
  },
  created() {
    this.getShffing();
    setTimeout(() => {
      this.goods();
    }, 500);
  },
  methods: {
    // 前往订单详情
    details(e) {
      this.$router.push({ path: "/details", query: { Id: e } });
    },
    // 积分变化
    IntegralChange(e) {
      this.Integral = e;
      this.goods();
    },
    //   页面加载请求
    getShffing() {
      const this_ = this;
      //   第一个请求是轮播第二个是列表请求
      axios
        .all([
          getHome.getBanner({ type: 3 }),
          getMall.getList({ page: 1, size: 15 }),
        ])
        .then((res) => {
          this_.shuffling = res[0].data.data;
          this_.mallList = res[1].data.data;
        });
      //
    },
    //商品请求
    goods(categoryid) {
      console.log('222222222222')
      console.log(this.Integral)
      this.selected = categoryid;
      const this_ = this;
      getMall
        .getGoods({ categoryid, range: this.Integral, page: 1, size: 15 })
        .then((res) => {
          this_.goodsList = res.data.data;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
// 选中过度
.selected {
  span {
    color: #fff;
  }
  p {
    display: block;
    width: 3rem;
    height: 5px;
    background: #6ebf64;
    position: relative;
    animation-name: anima;
    animation-duration: 1s;
    animation-fill-mode: forwards;
  }
}
// 商品详情下方动画
@keyframes anima {
  from {
    left: 0%;
  }
  to {
    left: 45%;
  }
}
//
.mall {
  // 轮播图
  .shuffling {
    img {
      width: 100vw;
    }
  }
  // 商品列表
  .mallList {
    display: flex;
    justify-content: center;
    background-color: #2bae85;
    padding: 0.5rem 0;
    div:hover {
      color: #f00;
    }
    div {
      flex: 1;
      text-align: center;
      color: #fff;
      span {
        font-size: 1rem;
      }
    }
  }
  // 商品
  .goodsList {
    display: flex;
    flex-wrap: wrap;
    width: 70vw;
    margin: auto;
    padding-top: 1rem;
    box-sizing: border-box;
    div:hover {
      width: 30%;
      box-shadow: 0px 5px 5px 5px rgba($color: #2bae85, $alpha: 0.5);
    }
    div {
      margin-right: 1.5rem;
      margin-top: 1rem;
      background: #ffffff;
      border: 0.1rem solid #eaeaea;
      width: 30%;
      P {
        line-height: 2rem;
        font-size: 1.2rem;
        margin-left: 0.2rem;
      }
      img {
        width: 100%;
        height: 30rem;
      }
    }
  }
}
.integralList {
  display: flex;
  width: 70vw;
  margin: auto;

  div {
    flex: 1;
    margin-left: 0.5rem;
    margin-top: 1rem;
    .el-button {
      padding: 0.5rem 0;

      text-align: center;
      width: 50%;
      border: 0.1rem solid #999;
      background: #fff;
      color: #000;
    }
    .clic {
      background: #6ebf64;
      color: #fff;
    }
    .el-button:hover {
      background: #6ebf64;
      color: #fff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/mall/index.vue